import { useTranslation } from 'react-i18next';
import { useUserRoles, useReportPermissions, useEngagementPermissions, useMarketplacePermissions } from '@anytag/auth';
import { InfluencerNewProfileHeaderV2 } from '@anytag/graphql';
import { Tabs, TabsProps } from '@anytag/shared-atoms';

export interface InfluencerTabsProps {
  influencerProfile: InfluencerNewProfileHeaderV2;
}

export const InfluencerTabs = ({
  influencerProfile: { id, youtubeAccounts, isTaggedToCompany }
}: InfluencerTabsProps) => {
  const { t } = useTranslation();
  const { hideReportLink } = useReportPermissions();
  const { hideEngagementReportLink } = useEngagementPermissions();
  const { hideMarketplaceReportLink } = useMarketplacePermissions();
  const { isAdminStaff, isAdminStaffTalentAgencyPartner } = useUserRoles();

  const hasCompareTab = youtubeAccounts?.findIndex((account) => account.analyticsEnabled) !== -1;
  const hasCampaignList = !hideReportLink && (!hideEngagementReportLink || !hideMarketplaceReportLink);
  const options: TabsProps['options'] = [
    {
      end: true,
      label: t('Influencer Profile'),
      to: '/influencer/$id/profile',
      params: { id: id.toString() }
    },
    {
      end: false,
      label: t('Compare'),
      hidden: !isAdminStaffTalentAgencyPartner || !hasCompareTab,
      to: '/influencer/$id/profile/compare',
      params: { id: id.toString() }
    },
    {
      end: true,
      label: t('Campaign List'),
      hidden: !isAdminStaff || isTaggedToCompany === false || !hasCampaignList,
      to: '/influencer/$id/profile/campaigns',
      params: { id: id.toString() }
    }
  ];

  return options.length ? <Tabs options={options} className="mb-4 border-none px-4" /> : null;
};
